export default [
  {
    path: 'logs',
    name: 'logs',
    component: () => import('@/views/Log/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-logs',
      template: 'auth',
    },
  },
  {
    path: 'log-content/:id',
    name: 'logContent',
    component: () => import('@/views/Log/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-logs',
      template: 'auth',
    },
  },
];
